import React from 'react';
import {connect} from 'react-redux';
import {setDefaultTableVisible} from '../../../common/tables/actions';

class Homepage extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        defaultTablesVisible: React.PropTypes.bool,
        setDefaultTableVisible: React.PropTypes.func
    };

    render() {
        const {setDefaultTableVisible, defaultTablesVisible, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.homepage.title}</span>
                        <span className="settings-name-info">{msg.settings.homepage.subtitle}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div
                            className={`switch-option text-l ${!defaultTablesVisible ? 'active' : ''} color-greenLight`}
                            onClick={() => setDefaultTableVisible(false)}>
                            <div className="switch-inner">
                                <span>{msg.settings.homepage.goods}</span>
                            </div>
                        </div>
                        <div
                            className={`switch-option text-l ${defaultTablesVisible ? 'active' : ''} color-greenLight`}
                            onClick={() => setDefaultTableVisible(true)}>
                            <div className="switch-inner">
                                <span>{msg.settings.homepage.tables}</span>
                            </div>
                        </div>
                    </div>
              </div>
            </div>
        );

    }

}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    defaultTablesVisible: state.tables.get('defaultTablesVisible'),
}), {setDefaultTableVisible})(Homepage);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/Homepage.js